import React, { useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import OrdersTable from "./components/OrdersTable";
import SubscriptionTable from "./components/SubscriptionTable";
import JsonViewer from "./components/JsonViewer";
import FilterModal from "./components/FilterModal";
import SubscriptionModal from "./components/SubscriptionModal.js";

function App() {
  const [tab, setTab] = useState(0);
  const [jwtToken, setJwtToken] = useState("");
  const [showError, setShowError] = useState(false);
  const [showErrorLog, setShowErrorLog] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);
  const [statusCode, setStatusCode] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [ordersApply, setOrdersApply] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [state, setState] = useState("");
  const [subscriptionBtn, setSubscriptionBtn] = useState("");
  const [sku, setSku] = useState("");
  const [consumerId, setConsumerId] = useState("");

  const handleTabChange = (_, newValue) => setTab(newValue);
  const handleJwtSubmit = async () => {
    if (!jwtToken) setShowError(true);
    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        authorization: `Bearer ${jwtToken}`,
      },
    };
    localStorage.setItem("bloomCredit", jwtToken);

    try {
      const res = await fetch(
        "https://sandbox.bloom.dev/v2/core/organization",
        options
      );
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data = await res.json();
      setTab(1);
    } catch (err) {
      console.error("JWT fetch error:", err);
      setShowErrorLog(true);
    }
  };

  return (
    <Container
      maxWidth="md"
      sx={{ mt: 4 }}
    >
      <Typography
        variant="h5"
        gutterBottom
      >
        Bloom Credit Data Access Explorer
      </Typography>
      <Typography
        gutterBottom
        mb={3}
        mt={3}
      >
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry's standard dummy text ever
        since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book.
      </Typography>
      <Paper>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="fullWidth"
        >
          <Tab label="JWT Token" />
          <Tab label="Orders" />
          <Tab label="Subscriptions" />
          <Tab label="GQL" />
        </Tabs>
        <Box sx={{ p: 2 }}>
          {tab === 0 && (
            <Box
              display="flex"
              gap={2}
            >
              <TextField
                fullWidth
                label="JWT Token"
                value={jwtToken}
                onChange={(e) => setJwtToken(e.target.value)}
              />
              <Button
                variant="contained"
                onClick={handleJwtSubmit}
              >
                Apply
              </Button>
            </Box>
          )}
          {tab === 1 &&
            (jwtToken ? (
              <OrdersTable
                openFilter={() => setFiltersOpen(true)}
                statusCode={statusCode}
                startDate={startDate}
                endDate={endDate}
                ordersApply={ordersApply}
                setOrdersApply={setOrdersApply}
                consumerId={consumerId}
              />
            ) : (
              <Alert severity="error">
                Authentication Error. Please check JWT Token.
              </Alert>
            ))}
          {tab === 2 &&
            (jwtToken ? (
              <SubscriptionTable
                openFilter={() => setSubscriptionOpen(true)}
                frequency={frequency}
                state={state}
                subscriptionBtn={subscriptionBtn}
                setSubscriptionBtn={setSubscriptionBtn}
                sku={sku}
              />
            ) : (
              <Alert severity="error">
                Authentication Error. Please check JWT Token.
              </Alert>
            ))}
          {tab === 3 &&
            (jwtToken ? (
              <JsonViewer />
            ) : (
              <Alert severity="error">
                Authentication Error. Please check JWT Token.
              </Alert>
            ))}
        </Box>
      </Paper>

      <FilterModal
        open={filtersOpen}
        onClose={() => setFiltersOpen(false)}
        statusCode={statusCode}
        setStatusCode={setStatusCode}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setOrdersApply={setOrdersApply}
        consummerId={consumerId}
        setConsumerId={setConsumerId}
      />
      <SubscriptionModal
        open={subscriptionOpen}
        onClose={() => setSubscriptionOpen(false)}
        frequency={frequency}
        setFrequency={setFrequency}
        state={state}
        setState={setState}
        setSubscriptionBtn={setSubscriptionBtn}
        sku={sku}
        setSku={setSku}
      />
      <Snackbar
        open={showError}
        autoHideDuration={3000}
        onClose={() => setShowError(false)}
      >
        <Alert
          severity="error"
          onClose={() => setShowError(false)}
        >
          JWT Token is required
        </Alert>
      </Snackbar>
      <Snackbar
        open={showErrorLog}
        autoHideDuration={3000}
        onClose={() => setShowErrorLog(false)}
      >
        <Alert
          severity="error"
          onClose={() => setShowErrorLog(false)}
        >
          JWT is invalid
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default App;
